import { render, staticRenderFns } from "./ReportRecipient.vue?vue&type=template&id=d33d4044&"
import script from "./ReportRecipient.vue?vue&type=script&lang=js&"
export * from "./ReportRecipient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports